import React from "react";
import Spinner from "./components/Spinner";
import Pagination from "../Pagination/Pagination";

const DataTable = ({
  items,
  headers,
  TableRow,
  pageSize: PageSize = 10,
  paginationDetails,
  setSearchParam,
  currenTab,
  additionalParam,
  onDelete, // ✅ add this
}) => {
  const adsStatus = 'not loading'
  const desktopHeaders = headers.filter((item) => item.visibleOnMobile);
  const mobileHeaders = headers.filter((item) => !item.visibleOnMobile && !item.visibleOnMobileOnly);
  const visibleOnlyOnMobile = headers.filter((item) => item.visibleOnMobileOnly);

  return (
    <>
      {adsStatus === "loading" ? (
        <Spinner/>
      ) : (
        <>
          <div className="mx-4 md:mx-10">
            <div className="flex flex-col">
              <div className="overflow-x-auto">
                <div className="inline-block min-w-full align-middle">
                  <div className="overflow-hidden">
                    <table className="min-w-full divide-y-2 divide-wwlGray200 sm:divide-wwlGreen">
                      <thead className="bg-transparent">
                        <tr>
                          {desktopHeaders.map((item, index) => (
                            <th
                              key={index}
                              scope="col"
                              className="bg-wwlWhite cursor-pointer whitespace-nowrap font-chivo pr-3 py-3.5 text-left text-wwlBlack"
                            >
                              <div className="flex items-center max-w-fit">
                                {item.title}
                              </div>
                            </th>
                          ))}

                          {mobileHeaders.map((item, index) => (
                            <th
                              key={index}
                              scope="col"
                              className="hidden sm:table-cell cursor-pointer whitespace-nowrap font-chivo pr-3 py-3.5 text-left text-wwlBlack bg-wwlWhite"
                            >
                              <div className="flex items-center max-w-fit">
                                {item.title}
                              </div>
                            </th>
                          ))}

                          {visibleOnlyOnMobile.map((item, index) => (
                            <th
                              key={index}
                              scope="col"
                              className="sm:hidden cursor-pointer whitespace-nowrap font-chivo pr-3 py-3.5 text-left text-wwlGray500 bg-wwlWhite font-medium text-sm "
                            >
                              <div className="flex items-center max-w-fit cursor-pointer">
                                {item.title}
                              </div>
                            </th>
                          ))}

                          <th
                            key='Actions'
                            scope="col"
                            className="px-3 py-3.5 whitespace-nowrap hidden sm:block text-left font-chivo text-wwlBlack bg-wwlWhite sm:pl-6 transition-colors duration-300"
                          >
                            <div className="flex items-center">Actions</div>
                          </th>
                        </tr>
                      </thead>

                      <tbody className="divide-y divide-wwlGray200 sm:divide-wwlGreenTransparent bg-wwlWhite">
                        {items?.map((item, index) => (
                          <TableRow
                            key={item._id}
                            item={item}
                            index={index}
                            currentTab={currenTab}
                            totalItems={items.length}
                            additionalParam={additionalParam}
                            onDelete={onDelete} // ✅ pass it through
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Pagination
            currentPage={Number(paginationDetails.currentPage)}
            totalCount={paginationDetails.totalCount}
            pageSize={PageSize}
            onPageChange={(page) => {
              setSearchParam({page});
            }}
          />
        </>
      )}
    </>
  );
};

export default DataTable;